import {
    FormStepper,
    EntityFormGeneralDataSection,
    EntityFormCaracteristicasSection,
} from "base/component/form";
import {
    DepositoFormGeneralDataFields,
    DepositoFormCaracteristicasFields,
    DepositoFormLocationFields,
} from ".";
import Box from "@mui/material/Box";

const DepositoCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<DepositoFormGeneralDataFields />}
            location={<DepositoFormLocationFields isCreationForm={true} />}
        />,
        <EntityFormCaracteristicasSection
            fields={<DepositoFormCaracteristicasFields />}
        />,
    ];
    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default DepositoCreationForm;
